var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"p-0",attrs:{"id":"header-section"}},[_c('Navbar'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }